<template>
  <div class="mt-5" >
    <slider
      ref="slider$"
      v-model="input.value"
      v-bind="input"
      @update="$emit('sliderOutPut', $event)"
      @change="$emit('sliderOutPutFetch', $event)"
      @drag="$emit('sliderOutPutFetch', $event)"
      :keyboard="true"
      class="slider"
      type="range"
      name="Punkteslider"
    >
    </slider>
  </div>
</template>

<script>
import Slider from "@vueform/slider";
import { computed, ref, onMounted } from "vue";

export default {
  name: "InputSlider",
  props: ["min", "max", "defaultRange", "step"],
  emits: ["sliderOutPut", "sliderOutPutFetch"],
  components: {
    Slider,
  },
  inheritAttrs: false,
  setup(props, { emit }) {
    const slider$ = ref(null);

    const setDate = (value) => {
      slider$.value.update(value);
    };
    const getCurData = computed(() => {
      return JSON.stringify(slider$.value.input);
    });

    const waitForSliderHandles = () => {
      const lowerHandle = document.querySelector(".slider-handle-lower");
      const upperHandle = document.querySelector(".slider-handle-upper");

      if (lowerHandle && upperHandle) {
        // Check if handles exist before setting attributes
        if (lowerHandle) {
          lowerHandle.setAttribute("aria-label", "Minimalen Punktwert auswählen");
          lowerHandle.setAttribute("title", "Minimalen Punktwert auswählen");
          lowerHandle.setAttribute("name", "Minimalen Punktwert auswählen");
        }
        if (upperHandle) {
          upperHandle.setAttribute("aria-label", "Maximalen Punktwert auswählen");
          upperHandle.setAttribute("title", "Maximalen Punktwert auswählen");
          upperHandle.setAttribute("name", "Maximalen Punktwert auswählen");
        }
      } else {
        // Retry after 100ms
        setTimeout(waitForSliderHandles, 100);
      }
    };

    onMounted(() => {
      document.querySelector(".slider-handle-lower").setAttribute("title", "Minimalen Punktwert auswählen");
      document.querySelector(".slider-handle-upper").setAttribute("title", "Maximalen Punktwert auswählen");
    });

    return {
      input: {
        value: props.defaultRange,
        tooltips: false,
        lazy: false,
        min: props.min,
        max: props.max,
        step: props.step || 1,
      },
      setDate,
      getCurData,
      slider$
    };
  },
 
};
</script>

<style src="../../../node_modules/@vueform/slider/themes/default.css"></style>
<style lang="postcss" scoped>
.slider {
  --slider-connect-bg: #7fa2d4;
  --slider-tooltip-bg: #3b82f6;
  --slider-handle-ring-color: #3b82f630;
  --slider-height: 15px;
  --slider-radius: 9999px;

  --slider-handle-bg: linear-gradient(to bottom, #f5faff 0, #fff 100%);
  --slider-handle-border: 0;
  --slider-handle-width: 1.9rem;
  --slider-handle-height: 1.9rem;
  --slider-handle-radius: 9999px;
  --slider-handle-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
  --slider-handle-shadow-active: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.42);
  --slider-handle-ring-width: 3px;
  --slider-handle-ring-color: rgba(7, 7, 7, 0.80);
}
.slider-handle:focus {
    outline: 2px solid #000 !important;
    outline-offset: 4px;
}   
</style>
